import React, { useMemo } from 'react'

import dayjs from 'dayjs'

import { filterStudent } from './utils'
import { useStudents } from '../../../../../context'
import { Cupon, listHeads } from '../../../../../types'
import { transformDate } from '../../../../../utilFunctions/transformFunc'
import { Spacer } from '../../../../global'
import { TableContainer } from '../../../../lists/styles'

const AdminDueBonusList = ({ bonus }: { bonus: Cupon[] }) => {
  const { studentsList } = useStudents()
  const dueBonus = useMemo(() => {
    return bonus.filter((bonus) => dayjs(bonus.dueDate).isBefore(dayjs()))
  }, [bonus])

  const finalizedBonus = useMemo(() => {
    return bonus.filter((bonus) => !dayjs(bonus.dueDate).isBefore(dayjs()))
  }, [bonus])

  return (
    <TableContainer>
      <div className="t-row t-head bonus-list debt">
        {listHeads.due.map((item, i) => {
          return <div key={i}>{item}</div>
        })}
      </div>
      <Spacer height={10} />
      {finalizedBonus.map((cupon) => {
        return (
          <div className="t-row bonus-list" key={cupon.uid}>
            <div className="with-image">
              <div
                className="profile-image"
                style={{
                  backgroundImage: `url(${filterStudent(cupon.idStudent, studentsList).image})`,
                }}
              ></div>
              {filterStudent(cupon.idStudent, studentsList).name}
            </div>
            <div>{cupon.amountOfClasses || 0} clases</div>
            <div>{cupon.attendance || 0}</div>
            <div className="red" style={{ fontSize: '12px' }}>
              <>Finalizado</>
            </div>
          </div>
        )
      })}
      {dueBonus.map((cupon) => {
        return (
          <div className="t-row bonus-list" key={cupon.uid}>
            <div className="with-image">
              <div
                className="profile-image"
                style={{
                  backgroundImage: `url(${filterStudent(cupon.idStudent, studentsList).image})`,
                }}
              ></div>
              {filterStudent(cupon.idStudent, studentsList).name}
            </div>
            <div>{cupon.amountOfClasses || 0} clases</div>
            <div>{cupon.attendance || 0}</div>
            <div className="red" style={{ fontSize: '12px' }}>
              <>Vencido el: {transformDate(cupon.dueDate)}</>
            </div>
          </div>
        )
      })}
    </TableContainer>
  )
}

export default AdminDueBonusList
